import { Variant } from '@kizi/core-components';
import p from './paragraphs';

const anchorRegular: Variant = {
  ...p.bodyRegular,
  color: 'info',
  textDecoration: 'none',
  '&:hover': {
    color: 'text',
    textDecoration: 'underline',
  },
  '&:active': {
    textDecoration: 'none',
  },
};

const inputFootnote: Variant = {
  ...p.footnoteRegular,
  color: 'info',
  fontSize: 2,
  textDecoration: 'none',
  '&:active, &:hover': {
    color: 'text',
    textDecoration: 'underline',
  },
};

const footnoteImportant: Variant = {
  ...p.footnoteImportant,
};

const helpContact: Variant = {
  ...footnoteImportant,
  fontSize: [2, null, 3],
  lineHeight: '',
};

const anchors = {
  anchorRegular,
  inputFootnote,
  footnoteImportant,
  helpContact,
};

export default anchors;
